import React, { useCallback } from 'react';

import Box from '@mui/material/Box';

import SubjectItemGridCard from './SubjectItemGridCard';
import SubjectItemListCard from './SubjectItemListCard';

export interface SubjectItemCardProps<TItem> {
  loading?: boolean;
  getName?: (item?: TItem) => React.ReactNode;
  getBackgroundImage?: (item?: TItem) => string;

  item?: TItem;
  onSelectItem?: (item: TItem) => void;
}

const SubjectItemCard = <TItem extends object>(props: SubjectItemCardProps<TItem>) => {
  const { getName, getBackgroundImage, loading, item, onSelectItem } = props;

  const handleSelectItem = useCallback(() => {
    if (onSelectItem && item) {
      onSelectItem(item);
    }
  }, [item, onSelectItem]);
  return (
    <>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <SubjectItemGridCard item={item} getName={getName} getBackgroundImage={getBackgroundImage} loading={loading} onClick={handleSelectItem} />
      </Box>
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        <SubjectItemListCard item={item} getName={getName} getBackgroundImage={getBackgroundImage} loading={loading} onClick={handleSelectItem} />
      </Box>
    </>
  );
};

export default SubjectItemCard;
